import React from "react";
import "../../App.css";
import { withCookies } from "react-cookie";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import History from "../commons/History";
import {
	MdAccountTree,
	MdApps,
	MdAssessment,
	MdBlock,
	MdBolt,
	MdBugReport,
	MdBusiness,
	MdCategory,
	MdCloudUpload,
	MdColorLens,
	MdDashboard,
	MdFactory,
	MdFlag,
	MdFlashOn,
	MdHome,
	MdInfo,
	MdInventory,
	MdListAlt,
	MdMemory,
	MdMoreHoriz,
	MdPeople,
	MdPolicy,
	MdReceipt,
	MdReceiptLong,
	MdSecurity,
	MdSettings,
	MdStar,
	MdSummarize,
	MdSystemUpdate,
	MdTerminal,
	MdTune
} from "react-icons/md";
const styles = theme => ({
	theme: theme,
	root: {
		display: "flex"
	},
	listItem: {
		borderRadius: 8,
		"&:hover": {
			borderRadius: 8
		},
		"&:hover $chevron": {
			visibility: "visible"
		}
	},
	chevron: {
		visibility: "hidden"
	}
});

// Desired sidebar grouping/sequence, keyed by url (labels can differ by policy — e.g.
// "CSV Uploader" vs "Bulk Activator" both use /csvbundle_uploader — so group by url, not text).
const MENU_GROUPS = [
	{ title: "Overview", icon: <MdHome size={22} />, urls: ["/", "/poscount"] },
	{ title: "Activation", icon: <MdBolt size={22} />, urls: ["/authwalls", "/csvbundle_uploader", "/csvlinuxbundle_uploader", "/updater"] },
	{ title: "Appearance", icon: <MdColorLens size={22} />, urls: ["/uiconfigs", "/skintvlaunchers", "/skinbuilder"] },
	{ title: "Configuration", icon: <MdTune size={22} />, urls: ["/features"] },
	{ title: "Reports", icon: <MdAssessment size={22} />, urls: ["/reports", "/featurelmslists", "/launcherlmslists"] },
	{ title: "Orders", icon: <MdReceipt size={22} />, urls: ["/pos"] },
	{ title: "Master Data", icon: <MdInventory size={22} />, urls: ["/resources", "/boards", "/vendors", "/Factories", "/attributes"] },
	{ title: "System", icon: <MdInfo size={22} />, urls: ["/about"] }
];

// const OTHER_GROUP_ICON = <MdMoreHoriz size={22} />;

// Groups the built menu items per MENU_GROUPS (in the specified order). Anything not covered by
// MENU_GROUPS (e.g. Blacklist, Firmwares, Logs, ...) is kept — grouped into an "Other"
// section placed just before "System" — rather than silently dropped.
function groupMenu(actions) {
	var byUrl = {};
	actions.forEach(a => { byUrl[a.url] = a; });
	var used = {};

	var groups = MENU_GROUPS.map(g => {
		var items = g.urls.map(url => byUrl[url]).filter(Boolean);
		items.forEach(item => { used[item.url] = true; });
		return { title: g.title, icon: g.icon, items: items };
	}).filter(g => g.items.length > 0);

	// "Other" group (catch-all for ungrouped items like Blacklist, Firmwares, Logs, ...) — disabled per request.
	// var leftover = actions.filter(a => !used[a.url]);
	// if (leftover.length > 0) {
	// 	var otherGroup = { title: "Other", icon: OTHER_GROUP_ICON, items: leftover };
	// 	var systemIndex = groups.findIndex(g => g.title === "System");
	// 	if (systemIndex > -1) {
	// 		groups.splice(systemIndex, 0, otherGroup);
	// 	} else {
	// 		groups.push(otherGroup);
	// 	}
	// }
	return groups;
}

class Sidebar extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			component: "",
			open: false,
			menu: [],
			expandedGroups: {},
			currentPath: History.location.pathname
		};
		this.handleItemClick = this.handleItemClick.bind();
	}

	componentWillUnmount() {
		if (this._unlistenHistory) this._unlistenHistory();
	}

	// Accordion behavior: opening a group closes any other group that was open.
	toggleGroup = title => () => {
		this.setState(oldState => {
			var willOpen = !oldState.expandedGroups[title];
			var expandedGroups = {};
			if (willOpen) expandedGroups[title] = true;
			return { expandedGroups: expandedGroups };
		});
	};

	// Clicking a group icon while the sidebar rail is collapsed expands the drawer,
	// opens that group, and navigates to its first item (since there's nothing else to click).
	expandFromCollapsed = (title, firstUrl) => () => {
		this.setState({ expandedGroups: { [title]: true } });
		if (this.props.onExpandRequest) this.props.onExpandRequest();
		if (firstUrl) this.handleItemClick(firstUrl)();
	};
	componentDidMount() {
		this._unlistenHistory = History.listen(location => {
			this.setState({ currentPath: location.pathname });
		});
		if (this.props.cookies.cookies.policy) {
			var policy = JSON.parse(this.props.cookies.cookies.policy);
			var actions = [];
			actions.push({
				text: "Home",
				url: "/",
				icon: (
					<MdHome size={18} />
				)
			});
			
			var component = undefined;
			if(this.props.cookies.cookies.policyname === "admin")
			{
			actions.push({
				text: "Skin Builder",
				url: "/skinbuilder",
				icon: (
					<MdColorLens size={18} />
				)
			});
			policy.map(action => {
				switch (action) {
					case "authwalls":
						component = {
							text: "Authwalls",
							url: "/authwalls",
							icon: (
								<MdSecurity size={18} />
							)
						};
						actions.push(component);
						if(this.props.cookies.cookies.policyname === "admin")
							{
							component = {
							text: "Bundle Upload",
							url: "/bundle_upload",
							icon: (
								<MdCloudUpload size={18} />
							)
							};
						actions.push(component);
						}
						break;
					case "uploader":
						if(this.props.cookies.cookies.policyname === "admin")
						{
							component = {
								text: "Bundle Update",
								url: "/updater",
								icon: (
									<MdSystemUpdate size={18} />
								)
							};							
						}else
						{
							if(this.props.cookies.cookies.policyname === "cvte_lite")
							{
								component = {
									text: "Bundle Update",
									url: "/updater",
									icon: (
										<MdSystemUpdate size={18} />
									)
								};
							}
						}
						actions.push(component);						
						break;
					case "bundle_activator":
						if(this.props.cookies.cookies.policyname === "admin")
						{
						component = {
							text: "Bundle Activator",
							url: "/bundle_activator",
							icon: (
								<MdBolt size={18} />
							)
							};
						}
						actions.push(component);
						break;
					case "csvbundle_uploader":
						component = {
							text: "CSV Uploader",
							url: "/csvbundle_uploader",
							icon: (
								<MdReceiptLong size={18} />
							)
						};
						actions.push(component);
						break;
					case "csvbundle_uploader":
						component = {
							text: "csvbundle_uploader",
							url: "/csvbundle_uploader",
							icon: (
								<MdReceiptLong size={18} />
							)
						};
						actions.push(component);
						break;					
					case "csvlinuxbundle_uploader":
							component = {
								text: "Linux Activator",
								url: "/csvlinuxbundle_uploader",
								icon: (
									<MdTerminal size={18} />
								)
							};
							actions.push(component);
							break;									
					case "poscount":
							component = {
								text: "Summary",
								url: "/poscount",
								icon: (
									<MdSummarize size={18} />
								)
							};
							actions.push(component);
						break;							
					case "blacklists":
						component = {
							text: "Blacklist",
							url: "/blacklists",
							icon: (
								<MdBlock size={18} />
							)
						};
						actions.push(component);
						break;
					case "reports":
						component = {
							text: "Reports",
							url: "/reports",
							icon: (
								<MdAssessment size={18} />
							)
						};
						actions.push(component);
						break;
					case "monthreports":
						component = {
							text: "Monthreports",
							url: "/monthreports",
							icon: (
								<MdAssessment size={18} />
							)
						};
						actions.push(component);
						break;
					case "skintvlaunchers":
						if(this.props.cookies.cookies.policyname === "admin")
							{
							component = {
								text: "Skins",
								url: "/skintvlaunchers",
								icon: (
									<MdColorLens size={18} />
								)
							};
							actions.push(component);
							}
							break;		
					case "firmwares":
						if(this.props.cookies.cookies.policyname === "admin")
							{
						component = {
							text: "Firmwares",
							url: "/firmwares",
							icon: (
								<MdMemory size={18} />
							)
						};
						actions.push(component);
						}
						break;
					case "test_suite":
						component = {
							text: "Test Suite",
							url: "/test",
							icon: (
								<MdBugReport size={18} />
							)
						};
						actions.push(component);
						break;
					case "featurelmslists":
						component = {
							text: "Feature List",
							url: "/featurelmslists",
							icon: (
								<MdStar size={18} />
							)
						};
						actions.push(component);
						break;
					case "launcherlmslists":
						component = {
							text: "Launcher List",
							url: "/launcherlmslists",
							icon: (
								<MdApps size={18} />
							)
						};
						actions.push(component);
						break;
					case "users":
						if(this.props.cookies.cookies.policyname === "admin")
							{
						component = {
							text: "Users",
							url: "/users",
							icon: (
								<MdPeople size={18} />
							)
						};
						actions.push(component);
					}
						break;
					case "policies":
						component = {
							text: "Policies",
							url: "/policies",
							icon: (
								<MdPolicy size={18} />
							)
						};
						actions.push(component);
						break;
					case "actions":
						component = {
							text: "Actions",
							url: "/actions",
							icon: (
								<MdFlashOn size={18} />
							)
						};
						actions.push(component);
						break;
					case "pos":
							component = {
								text: "PO",
								url: "/pos",
								icon: (
									<MdReceipt size={18} />
								)
							};
							actions.push(component);
							break;	
					case "services":
						component = {
							text: "Services",
							url: "/services",
							icon: (
								<MdApps size={18} />
							)
						};
						actions.push(component);
						break;
					case "uiconfigs":
						if(this.props.cookies.cookies.policyname === "admin")
							{
						component = {
							text: "UIConfigs",
							url: "/uiconfigs",
							icon: (
								<MdSettings size={18} />
							)
						};
						actions.push(component);
						}
						break;
					case "features":
						if(this.props.cookies.cookies.policyname === "admin")
							{
						component = {
							text: "Features",
							url: "/features",
							icon: (
								<MdFlag size={18} />
							)
						};
						actions.push(component);
					}
						break;
					case "resources":
					if(this.props.cookies.cookies.policyname === "admin")
						{
							component = {
								text: "Boards",
								url: "/boards",
								icon: (
									<MdDashboard size={18} />
								)
							};
							actions.push(component);

							component = {
								text: "Brands",
								url: "/resources",
								icon: (
									<MdBusiness size={18} />
								)
							};
							actions.push(component);

							component = {
								text: "Vendors",
								url: "/vendors",
								icon: <MdAccountTree size={18} />
							};
							actions.push(component);

							component = {
								text: "Factories",
								url: "/Factories",
								icon: <MdFactory size={18} />
							};
							actions.push(component);

							component = {
									text: "Attributes",
									url: "/attributes",
									icon: (
										<MdCategory size={18} />
									)
							};
							actions.push(component);
						}
					else{
						component = {
							text: "Boards",
							url: "/boards",
							icon: (
								<MdDashboard size={18} />
							)
						};
						actions.push(component);
						component = {
							text: "Brands",
							url: "/resources",
							icon: (
								<MdBusiness size={18} />
							)
						};
						actions.push(component);
						component = {
							text: "Vendors",
							url: "/vendors",
							icon: <MdAccountTree size={18} />
						};
						actions.push(component);
						component = {
							text: "Factories",
							url: "/Factories",
							icon: <MdFactory size={18} />
						};
						actions.push(component);
					}
					break;
					/*
					case "emacconfigs":
						//if(this.props.cookies.cookies.policyname === "admin")
							{
						component = {
							text: "Emac Configs",
							url: "/emacconfigs",
							icon: (
								<MdFlag size={18} />
							)
						};
						actions.push(component);
					}
						break;
						/*
						component = {
							text: "Boards",
							url: "/boards",
							icon: (
								<MdDashboard size={18} />
							)
						};
						actions.push(component);
						component = {
							text: "Brands",
							url: "/resources",
							icon: (
								<MdBusiness size={18} />
							)
						};
						actions.push(component);
						if(this.props.cookies.cookies.policyname === "admin")
						{	
							component = {
								text: "Attributes",
								url: "/attributes",
								icon: (
									<MdCategory size={18} />
								)
							};
							actions.push(component);
							
							component = {
								text: "Vendors",
								url: "/vendors",
								icon: (
									<MdAccountTree size={18} />
								)
							};
							actions.push(component);
							
							component = {
								text: "Factorys",
								url: "/factorys",
								icon: (
									<MdFactory size={18} />
								)
							};
							actions.push(component);

						}	
						break;
						*/
					case "logs":
						component = {
							text: "LOGS",
							url: "/logs",
							icon: (
								<MdListAlt size={18} />
							)
						};
						actions.push(component);
						break;
				}
			});
			}
			else
			{
				policy.map(action => {
					switch (action) {
						case "authwalls":
							component = {
								text: "Authwalls",
								url: "/authwalls",
								icon: (
									<MdSecurity size={18} />
								)
							};
							actions.push(component);
							// if(this.props.cookies.cookies.policyname === "cvte_lite")
							// 	{
							// 	component = {
							// 	text: "Bundle Upload",
							// 	url: "/bundle_upload",
							// 	icon: (
							// 		<img
							// 			src={"./icons/bundle_upload.svg"}
							// 			width={"24px"}
							// 			height={"24px"}
							// 			alt={"M-AUTHWALL"}
							// 		/>
							// 	)
							// 	};
							// actions.push(component);
							// }
							break;
						case "csvbundle_uploader":
							component = {
								text: "Bulk Activator",
								url: "/csvbundle_uploader",
								icon: (
									<MdReceiptLong size={18} />
								)
							};
							actions.push(component);
							break;
						case "csvlinuxbundle_uploader":
								component = {
									text: "Linux Activator",
									url: "/csvlinuxbundle_uploader",
									icon: (
										<MdTerminal size={18} />
									)
								};
								actions.push(component);
								break;									
						case "poscount":
								component = {
									text: "Summary",
									url: "/poscount",
									icon: (
										<MdSummarize size={18} />
									)
								};
								actions.push(component);
							break;							
						case "blacklists":
							component = {
								text: "Blacklist",
								url: "/blacklists",
								icon: (
									<MdBlock size={18} />
								)
							};
							actions.push(component);
							break;
						case "reports":
							component = {
								text: "Reports",
								url: "/reports",
								icon: (
									<MdAssessment size={18} />
								)
							};
							actions.push(component);
							break;
						case "monthreports":
							component = {
								text: "Monthreports",
								url: "/monthreports",
								icon: (
									<MdAssessment size={18} />
								)
							};
							actions.push(component);
							break;
						case "skintvlaunchers":
							if(this.props.cookies.cookies.policyname === "admin")
								{
								component = {
									text: "Skins",
									url: "/skintvlaunchers",
									icon: (
										<MdColorLens size={18} />
									)
								};
								actions.push(component);
								}
								break;		
						case "featurelmslists":
							component = {
								text: "Feature List",
								url: "/featurelmslists",
								icon: (
									<MdStar size={18} />
								)
							};
							actions.push(component);
							break;
						case "launcherlmslists":
							component = {
								text: "Launcher List",
								url: "/launcherlmslists",
								icon: (
									<MdApps size={18} />
								)
							};
							actions.push(component);
							break;
						case "resources":
							component = {
								text: "Boards",
								url: "/boards",
								icon: (
									<MdDashboard size={18} />
								)
							};
							actions.push(component);
							component = {
								text: "Brands",
								url: "/resources",
								icon: (
									<MdBusiness size={18} />
								)
							};
							actions.push(component);
							component = {
								text: "Vendors",
								url: "/vendors",
								icon: <MdAccountTree size={18} />
							};
							actions.push(component);
							component = {
								text: "Factories",
								url: "/Factories",
								icon: <MdFactory size={18} />
							};
							actions.push(component);
						if(this.props.cookies.cookies.policyname === "admin")
						{
							component = {
								text: "Attributes",
								url: "/attributes",
								icon: (
									<MdCategory size={18} />
								)
							};
							actions.push(component);
						}
							break;
						case "pos":
							component = {
								text: "PO",
								url: "/pos",
								icon: (
									<MdReceipt size={18} />
								)
							};
							actions.push(component);
							break;
						case "logs":
							component = {
								text: "LOGS",
								url: "/logs",
								icon: (
									<MdListAlt size={18} />
								)
							};
							actions.push(component);
							break;
					}
				});

				if (!policy.includes('csvbundle_uploader') && this.props.cookies.cookies.policyname !== 'admin') {
					actions.push({
						text: "Bulk Activator",
						url: "/csvbundle_uploader",
						icon: (
							<MdReceiptLong size={18} />
						)
					});
				}
			}

			actions.push({
				text: "About",
				url: "/about",
				icon: (
					<MdInfo size={18} />
				)
			});
			var groups = groupMenu(actions);
			var expandedGroups = {};
			groups.forEach(g => { expandedGroups[g.title] = g.title === "Overview"; });
			this.setState({ menu: groups, expandedGroups: expandedGroups });
		}
	}
	
	handleItemClick = url => event => {
		this.setState({ url: url });
		//TODO: Route to url
		console.log(url);
		if (this.props.cookies.cookies.username == undefined) {
			window.location.reload();
		} else {
			History.push(url);
		}
	};

	render() {
		const { classes } = this.props;
		// Whether the outer drawer is expanded. Defaults to true so Sidebar still renders
		// correctly if ever used without the prop wired up.
		const sidebarOpen = this.props.open !== false;
		const currentPath = this.state.currentPath;
		return (
			<div className={classes.root}>
				<List dense disablePadding style={{ width: "100%" }}>
					{this.state.menu.map(group => {
						return (
							<React.Fragment key={group.title}>
								<ListItem
									button
									dense
									className={classes.listItem}
									onClick={sidebarOpen ? this.toggleGroup(group.title) : this.expandFromCollapsed(group.title, group.items[0] && group.items[0].url)}
									style={{
										justifyContent: !sidebarOpen ? "center" : undefined,
										paddingTop: 8,
										paddingBottom: 8
									}}
								>
									<ListItemIcon style={{ minWidth: sidebarOpen ? 36 : "auto" }}>{group.icon}</ListItemIcon>
									{sidebarOpen && (
										<ListItemText
											primary={group.title}
											primaryTypographyProps={{ style: { fontWeight: 500, fontSize: "1.05rem" } }}
										/>
									)}
									{sidebarOpen && (this.state.expandedGroups[group.title]
										? <ExpandLess className={classes.chevron} />
										: <ExpandMore className={classes.chevron} />)}
								</ListItem>
								{sidebarOpen && (
									<Collapse in={!!this.state.expandedGroups[group.title]} timeout="auto" unmountOnExit>
										<List component="div" disablePadding dense>
											{group.items.map(item => (
												<ListItem
													button
													dense
													className={classes.listItem}
													key={item.text}
													style={{
														paddingLeft: 60,
														paddingTop: 6,
														paddingBottom: 6,
														backgroundColor: item.url === currentPath ? "#e0e0e0" : undefined
													}}
													onClick={this.handleItemClick(item.url)}
												>
													<ListItemText
														primary={item.text}
														primaryTypographyProps={{ style: { fontSize: "1rem" } }}
													/>
												</ListItem>
											))}
										</List>
									</Collapse>
								)}
							</React.Fragment>
						);
					})}
				</List>
			</div>
		);
	}
}
export default withStyles(styles)(withCookies(Sidebar));

